import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=94922e06&scoped=true&"
import script from "./IconBox.vue?vue&type=script&lang=js&"
export * from "./IconBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94922e06",
  null
  
)

export default component.exports